import { Star } from "lucide-react";

const Stars = ({ value = 0, size = 16 }) => {
  const filled = Math.round(value);
  return (
    <div className="flex items-center gap-0.5" aria-label={`${value} out of 5 stars`} data-testid="stars">
      {[1,2,3,4,5].map((i) => (
        <Star key={i} size={size} className={i <= filled ? "vd-star" : "vd-star-empty"} fill={i <= filled ? "#FFB400" : "none"} stroke={i <= filled ? "#FFB400" : "var(--border-color)"} />
      ))}
    </div>
  );
};

export default Stars;
